// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ym3W","importantInfo":"styles_importantInfo__1ctxj"};